export const GOOGLE_TAG_MANAGER_ID = import.meta.env.VITE_APP_GOOGLE_TAG_MANAGER_ID as string;
